import './App.css';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ChatBotModal from './components/ChatBotModal';
import { FaRobot } from 'react-icons/fa';

import Routes from './routes/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import PubSub from 'pubsub-js';
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch , useSelector } from 'react-redux';
import { getUserServerInfo, setUserInfo } from './reducers/slice/userServerDataSlice';
import 'reactjs-popup/dist/index.css';
import CASTermsModal from './shared/Modal/CASTermsModal';
import { get, post } from './helpers/fetchServicesMethods';
import LogoutService from './services/logout';


const useStyles = makeStyles((theme) => ({
 
loaderHide: {
  display: 'none'
},

loader :{
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height:' 100%',
  zIndex: '999999',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  display: 'block',
  
  },
  loaderPosition:{
  marginLeft: '602px',
    marginTop: '300px',
  }

}));

function App() {
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [chatOpen, setChatOpen] = useState(false);
  const [chatInitialMsg, setChatInitialMsg] = useState('');
  const [selectionTooltip, setSelectionTooltip] = useState(null);
  const tooltipRef = useRef(null);
  const toggle = useSelector(state => state.setToggle.toggle);
  const userInfo = useSelector(state => state.setUserInfo);
  const isLoggedIn = !!(userInfo?.current_user?.login_name);
  const [showCASTerms, setShowCASTerms] = useState(false);

  function checkCASTermsNeeded(casAccess, cmAccess, casTermsAcceptedAt) {
    if (!casAccess && !cmAccess) return;
    if (casTermsAcceptedAt) {
      const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;
    if (Date.now() - new Date(casTermsAcceptedAt).getTime() < ONE_YEAR_MS) return;
    }
    setShowCASTerms(true);
  }

  async function handleAcceptCASTerms() {
    try {
      await post('do=gquser.accept_cas_terms&format=json', {});
    } catch (e) {
      console.error('Failed to save CAS terms acceptance:', e);
    }
    setShowCASTerms(false);
  }

  async function handleDeclineCASTerms() {
    setShowCASTerms(false);
    await LogoutService.logout();
    dispatch(setUserInfo({ current_user: {} }));
    window.location.hash = '/login';
  }

  useEffect(() => {
    if (!isLoggedIn) { setShowCASTerms(false); return; }
    get('do=gquser.get_info&format=json')
      .then(res => {
        const content = res?.response_content;
        checkCASTermsNeeded(Boolean(content?.casAccess), Boolean(content?.cmAccess), content?.cas_terms_accepted_at);
      })
      .catch((e) => { console.error('CAS terms check error:', e); });
  }, [isLoggedIn]); // eslint-disable-line react-hooks/exhaustive-deps

  // Show "Ask GQ Assist" tooltip on text selection
  const handleMouseUp = useCallback(() => {
    const selection = window.getSelection();
    const text = selection?.toString().trim();
    if (!text || text.length < 2) {
      setSelectionTooltip(null);
      return;
    }
    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    // Don't show if selection is inside the chatbot modal
    const chatModal = document.querySelector('.chatbot-modal-overlay');
    if (chatModal && chatModal.contains(range.startContainer)) {
      setSelectionTooltip(null);
      return;
    }
    setSelectionTooltip({
      text,
      top: rect.top + window.scrollY - 40,
      left: rect.left + window.scrollX + rect.width / 2,
    });
  }, []);

  const handleAskGQAssist = useCallback(() => {
    if (selectionTooltip?.text) {
      setChatInitialMsg(selectionTooltip.text);
      setChatOpen(true);
      setSelectionTooltip(null);
      window.getSelection()?.removeAllRanges();
    }
  }, [selectionTooltip]);

  // Hide tooltip on click outside or scroll
  useEffect(() => {
    const hideTooltip = (e) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setSelectionTooltip(null);
      }
    };
    const hideOnScroll = () => setSelectionTooltip(null);
    document.addEventListener('mousedown', hideTooltip);
    window.addEventListener('scroll', hideOnScroll, true);
    return () => {
      document.removeEventListener('mousedown', hideTooltip);
      window.removeEventListener('scroll', hideOnScroll, true);
    };
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      document.addEventListener('mouseup', handleMouseUp);
      return () => document.removeEventListener('mouseup', handleMouseUp);
    }
  }, [isLoggedIn, handleMouseUp]);

  useEffect(() => {
    // Add event listener for theme change
    if (toggle) {
      console.log(toggle, "toggle")
      // document.body.classList.remove('dark');
      document.documentElement.style.setProperty('--backgroundColor', '#ffffff');
      document.documentElement.style.setProperty('--appTextColor', '#777');
    } else {
        // document.body.classList.add('dark');
        document.documentElement.style.setProperty('--backgroundColor', '#292929');
        document.documentElement.style.setProperty('--appTextColor', 'white');
    }
}, [toggle]);

  useEffect(() => {
    dispatch(getUserServerInfo());
    async function fetchLoader() {
      const loaderResponse = await PubSub.subscribe('msg', (msg, data) => {
        setLoading(data)
      });
     
      
    }
    fetchLoader()
  }, [])
  return (
    <div className={toggle ? 'light' : 'darkTheme'}>
      <Routes />
      {/* Floating Chat Button */}
      {/* Chatbot button hidden for next release
      {isLoggedIn && <>
        <button
          style={{
            position: 'fixed',
            bottom: 28,
            right: 28,
            zIndex: 1001,
            borderRadius: 30,
            width: 'auto',
            height: 48,
            padding: '0 20px',
            background: 'linear-gradient(135deg, #3395ea, #395aea)',
            color: '#fff',
            border: 'none',
            boxShadow: '0 4px 14px rgba(51,122,183,0.5)',
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: '0.4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            transition: 'box-shadow 0.2s, transform 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(51,122,183,0.6)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(51,122,183,0.5)'; }}
          onClick={() => setChatOpen(true)}
          aria-label="Open ChatBot"
        >
          <FaRobot style={{ fontSize: 20 }} />
        </button>
        <ChatBotModal isOpen={chatOpen} onClose={() => setChatOpen(false)} initialMessage={chatInitialMsg} />
      </>}
      */}
      {/* Ask GQ Assist tooltip on text selection — hidden for next release
      {selectionTooltip && (
        <div
          ref={tooltipRef}
          onClick={handleAskGQAssist}
          style={{
            position: 'absolute',
            top: selectionTooltip.top,
            left: selectionTooltip.left,
            transform: 'translateX(-50%)',
            zIndex: 10000,
            background: 'linear-gradient(135deg, #337ab7, #318bd6)',
            color: '#fff',
            padding: '6px 14px',
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            userSelect: 'none',
            animation: 'fadeInUp 0.15s ease-out',
          }}
        >
          <FaRobot style={{ fontSize: 14 }} /> Ask GQ Assist
        </div>
      )}
      */}
      <CASTermsModal show={showCASTerms} onAccept={handleAcceptCASTerms} onDecline={handleDeclineCASTerms} />
      {/* Loader logic (unchanged) */}
      {loading ?
        <div className={classes.loader}>
          <div className={classes.loaderPosition}>
            <div className="spinner-container">
              <div className="spinner-socket">
                <div className="spinner-hex spinner-tile-1">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
                <div className="spinner-hex spinner-tile-2">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
                <div className="spinner-hex spinner-tile-3 spinner-row-2">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
                <div className="spinner-hex spinner-tile-4 spinner-row-2">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
                <div className="spinner-hex spinner-tile-5 spinner-row-2">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        :
        <div className={classes.loaderHide}>
          <div className={classes.loaderPosition}>
            <div className="spinner-container">
              <div className="spinner-socket">
                <div className="spinner-hex spinner-tile-1">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
                <div className="spinner-hex spinner-tile-2">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
                <div className="spinner-hex spinner-tile-3 spinner-row-2">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
                <div className="spinner-hex spinner-tile-4 spinner-row-2">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
                <div className="spinner-hex spinner-tile-5 spinner-row-2">
                  <div className="spinner-brick rotate-0"></div>
                  <div className="spinner-brick rotate-1"></div>
                  <div className="spinner-brick rotate-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default App;
